import { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveLogin } from "./redux/slices/mainDataSlice";
import "./main.scss";
import { Toaster } from "react-hot-toast";

import Tarwees from "./pages/school/Tarwees";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import Schools from "./pages/school/Schools";
import SchoolDetails from "./pages/school/SchoolDetails";
import AddSchool from "./pages/school/AddSchool";
import Finance from "./pages/finance/Finance";
import PublishNewVersion from "./pages/publish/PublishNewVersion";
import FindTeachers from "./pages/school/FindTeachers";
import EmployeeList from "./pages/school/EmployeeList";
import EditEmployeePage from "./pages/school/EditEmployee";
import EditHalfEmployee from "./pages/school/EditHalfEmployee";
import Holidays from "./pages/school/Holidays";
import HalfMrkaz from "./pages/school/HalfMrkaz";
import TasksHolidays from "./pages/school/TasksHolidays";
import WhatsNew from "./pages/publish/WhatsNew";
import Archive from "./pages/Archive";
import TransferredTeachers from "./pages/school/TransferredTeachers";
import SchoolNotes from "./pages/school/SchoolNotes";
import SchoolEvents from "./pages/school/SchoolEvents";
import AnnualEvents from "./pages/school/AnnualEvents";
import Notifications from "./pages/publish/Notifications";
import DashboardLayout from "./components/layout/DashboardLayout";
import SchoolConstants from "./pages/school/SchoolConstants";
import SchoolRenewal from "./pages/school/SchoolRenewal";
import ExtendSubscription from "./pages/school/ExtendSubscription";
import QuotaTable from "./pages/school/QuotaTable";
import RequirePermission from "./permissions/RequirePermission";
import Users from "./pages/users/Users";
import Roles from "./pages/roles/Roles";
import Account from "./pages/account/Account";

// Route guard shorthand: P("schools", <Schools />)
const P = (module, el) => (
  <RequirePermission module={module}>{el}</RequirePermission>
);

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const credentials = JSON.parse(localStorage.getItem("userCredentials"));
    if (credentials?.token) {
      dispatch(saveLogin(credentials));
    }
  }, [dispatch]);

  return (
    <>
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          style: {
            background: "rgba(255, 255, 255, 0.96)",
            color: "#22302d",
            backdropFilter: "blur(14px)",
            WebkitBackdropFilter: "blur(14px)",
            borderRadius: "6px",
            border: "1px solid rgba(13, 35, 32, 0.1)",
            boxShadow:
              "0 18px 45px rgba(13, 35, 32, 0.12)",
            padding: "10px 14px",
            direction: "rtl",
            fontFamily: "'Cairo', system-ui, -apple-system, BlinkMacSystemFont",
            fontSize: "13px",
            alignItems: "center",
          },
          duration: 3500,
          success: {
            iconTheme: {
              primary: "#16a34a",
              secondary: "rgba(255, 255, 255, 0.95)",
            },
          },
          error: {
            iconTheme: {
              primary: "#dc2626",
              secondary: "rgba(255, 255, 255, 0.95)",
            },
          },
        }}
        containerStyle={{
          top: 18,
        }}
      />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route element={<DashboardLayout />}>
          <Route path="/home" element={P("dashboard", <Home />)} />
          <Route path="/schools" element={P("schools", <Schools />)} />
          <Route path="/schools/:rgmw" element={P("schools", <SchoolDetails />)} />
          <Route path="/add-school" element={P("schools", <AddSchool />)} />
          <Route path="/all-schools" element={<Navigate to="/schools" replace />} />
          <Route path="/finance" element={P("finance", <Finance />)} />
          <Route path="/publish-new-version" element={P("versions", <PublishNewVersion />)} />
          <Route path="/find-teachers" element={P("employees", <FindTeachers />)} />
          <Route path="/school/:rgmw/employees" element={P("employees", <EmployeeList />)} />
          <Route path="/schools/:rgmw/employees" element={P("employees", <EmployeeList />)} />
          <Route path="/editEmployee/:emp_id" element={P("employees", <EditEmployeePage />)} />
          <Route path="/editHalfEmployee/:emp_id" element={P("employees", <EditHalfEmployee />)} />
          <Route path="/holidays" element={P("holidays", <Holidays />)} />
          <Route path="/half-mrkaz" element={P("employees", <HalfMrkaz />)} />
          <Route path="/tarwees" element={P("tarwees", <Tarwees />)} />
          <Route path="/tasks-holidays" element={P("holidays", <TasksHolidays />)} />
          <Route path="/whats-new" element={P("whats_new", <WhatsNew />)} />
          <Route path="/archive" element={P("archive", <Archive />)} />
          <Route path="/transferred-teachers" element={P("employees", <TransferredTeachers />)} />
          <Route path="/school-notes" element={P("school_notes", <SchoolNotes />)} />
          <Route path="/school-events" element={P("holidays", <SchoolEvents />)} />
          <Route path="/annual-events" element={P("holidays", <AnnualEvents />)} />
          <Route path="/notifications" element={P("notifications", <Notifications />)} />
          <Route path="/school-constants" element={P("school_constants", <SchoolConstants />)} />
          <Route path="/school-renewal" element={P("schools", <SchoolRenewal />)} />
          <Route path="/extend-subscription" element={P("schools", <ExtendSubscription />)} />
          <Route path="/users" element={P("users", <Users />)} />
          <Route path="/roles" element={P("roles", <Roles />)} />
          <Route path="/account" element={<Account />} />
          <Route path="/quota" element={P("schools", <QuotaTable />)} />

        </Route>
        <Route path="/*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
}

export default App;
